import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 客戶訂單 Detail（含根層 schedules／lines／materials／extra_items／sales_orders／snapshot）。
 *
 * @param {string} id
 */
export async function fetchCustomerOrderDetail(id) {
  const { data: raw } = await request.get(`/crm/customer-order/${id}`);
  return parseVer4DetailResponse(raw);
}
